import { WalletPaymentMethodIdentifier } from '@platform-frontend/marketplace';

export interface GooglePayPaymentData extends WalletPaymentMethodIdentifier {
  type: 'GOOGLE_PAY';
  paymentData: google.payments.api.PaymentData;
}
